/* eslint-disable no-param-reassign */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { initialize } from "../../actions";
import { CONTACT_LISTING_AGENT_MUTATION } from "../../graphql-documents/contactListingAgent.mutation";

export const contactListingAgent = createAsyncThunk(
  "contactListingAgent",
  async (data, { extra }) => {
    const { deviceFingerprintService, graphqlMutationService } = extra;

    return graphqlMutationService
      .mutate({
        mutation: CONTACT_LISTING_AGENT_MUTATION,
        variables: {
          input: {
            device_fingerprint: deviceFingerprintService.get(),
            message_details: {
              email_content: data.message,
              sender_email: data.email,
              sender_name: data.name,
              sender_phone: data.phone,
              email_subject: `About ${data.propertyAddress}`,
              experts_api_uuid: data.expertsApiUuid,
              origin_label: "seller_agent_profile_exp_hdp"
            },
            sale_id: data.listingId
          }
        }
      })
      .then(result => {
        const { analyticsService } = extra;

        const formErrorsPresent = Boolean(
          result.data?.contact_sale_listing_agent?.errors
        );

        if (!formErrorsPresent) {
          analyticsService.sendContactAgentEvent({
            saleId: data.listingId,
            expertsApiUuid: data.expertsApiUuid,
            fromSource: data.fromSource
          });
        }

        return result;
      });
  }
);

const initialState = {
  expertsApiUuid: null,
  fromSource: null,
  listingId: null
};

const contactFormSlice = createSlice({
  name: "contactForm",
  initialState,
  reducers: {
    setExpertInfo(state, action) {
      const { expertsApiUuid, fromSource, listingId } = action.payload;

      state.expertsApiUuid = expertsApiUuid;
      state.fromSource = fromSource;
      state.listingId = listingId;
    }
  },
  extraReducers: {
    [initialize]: (state, action) => {
      state.propertyAddress = action.payload.propertyAddress;
    },
    [contactListingAgent.fulfilled]: (state, action) => {
      const errors = action.payload?.data?.contact_sale_listing_agent?.errors;

      state.errors = errors;
    }
  }
});

export const { setExpertInfo } = contactFormSlice.actions;

export default contactFormSlice.reducer;
